import { inject, Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UserService } from '../user/user.service';
import { UserService as User } from '../user.service';
import { AppRoutes } from 'src/app/config/routes.config';
import { CountryService } from '@shared/services/country.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { PermissionCode } from '../../constants/permission-code';
import { ModuleCodes } from '../../constants/module-code';
@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  public userRoles = new BehaviorSubject<any>(this.userService.getUserInfoFromLocalStorage());
  public hasPermission = false;
  private permissionSubject = new BehaviorSubject<boolean>(false);

  // Observable cho các component khác subscribe
  public hasPermission$: Observable<boolean> = this.permissionSubject.asObservable();

  constructor(
    private tokenStorageService: TokenStorageService,
    private authService: AuthService,
    private userService: UserService,
    private user: User,
    private countryService: CountryService
  ) {}
  private ngxPermissionService = inject(NgxPermissionsService);

  checkPermission(requiredRoles: string[], roles: string[]) {
    const tokenId = this.tokenStorageService.getToken(); // || get token from cookie
    const isTokenValid = this.authService.isTokenExpired();
    // Check if the token is expired or invalid
    if (tokenId && !isTokenValid) {
      const hasPermission = requiredRoles.some((permission) => roles.includes(permission));
      return hasPermission;
    }
    return false;
  }

  async checkPermission1(token?: string, countryCode: string = ''): Promise<boolean> {
    const path = window.location.pathname;
    const pathSegment = path.split('/')[1];
    return new Promise<boolean>(async (resolve) => {
      let hasPermission = false;
      let tokenId: string | null = '';
      if (token) {
        tokenId = token;
      } else {
        tokenId = this.tokenStorageService.getToken();
      }

      if (tokenId) {
        try {
          const res = await this.user.getModeratorRole(tokenId, countryCode).toPromise();
          if (res && res.length > 0) {
            if (res.includes(PermissionCode.SUPER_ADMIN)) {
              hasPermission = true;
            } else {
              if (pathSegment && pathSegment === AppRoutes.ADMIN) {
                hasPermission = res.some((role) =>
                  [
                    PermissionCode.BANNER_SOCIAL_ACCESS,
                    PermissionCode.BANNER_CAR_ACCESS,
                    PermissionCode.BANNER_FLIGHT_ACCESS,
                    PermissionCode.BANNER_FOOD_ACCESS,
                    PermissionCode.BANNER_HOTEL_ACCESS,
                    PermissionCode.BANNER_SHOP_ACCESS,
                    PermissionCode.BANNER_TRAVEL_ACCESS,
                    PermissionCode.BANNER_MEMBERSHIP_ACCESS,
                  ].includes(role as PermissionCode)
                );
              } else {
                switch (pathSegment?.replaceAll('-', '_').toUpperCase()) {
                  case ModuleCodes.CAR:
                    hasPermission = res.includes(PermissionCode.BANNER_CAR_ACCESS);
                    break;
                  case ModuleCodes.FLIGHT:
                    hasPermission = res.includes(PermissionCode.BANNER_FLIGHT_ACCESS);
                    break;
                  case ModuleCodes.HOTEL:
                    hasPermission = res.includes(PermissionCode.BANNER_HOTEL_ACCESS);
                    break;
                  case ModuleCodes.RESTAURANT:
                    hasPermission = res.includes(PermissionCode.BANNER_FOOD_ACCESS);
                    break;
                  case ModuleCodes.SHOP:
                    hasPermission = res.includes(PermissionCode.BANNER_SHOP_ACCESS);
                    break;
                  case ModuleCodes.SOCIAL:
                    hasPermission = res.includes(PermissionCode.BANNER_SOCIAL_ACCESS);
                    break;
                  case ModuleCodes.TRAVEL_TOUR:
                    hasPermission = res.includes(PermissionCode.BANNER_TRAVEL_ACCESS);
                    break;
                  default:
                    hasPermission = false;
                }
              }
            }
            this.setPermission(hasPermission);
            this.ngxPermissionService.loadPermissions(res);
          } else {
            hasPermission = false;
            this.setPermission(hasPermission);
            this.ngxPermissionService.loadPermissions([]);
          }
        } catch (error) {
          console.error(error);
        }
      }
      // if (locationUrl && locationUrl !== AppRoutes.ADMIN) {
      //   hasPermission = true;
      // }

      return resolve(hasPermission);
    });
  }

  setPermission(value: boolean) {
    this.permissionSubject.next(value);
  }

  getCurrentPermission(): boolean {
    return this.permissionSubject.getValue();
  }
}
